<template>
  <v-dialog v-model="dialog" persistent width="500">
    <v-card>
      <v-card-title class="d-flex">
        Scan QR Code For Recharge
        <v-spacer></v-spacer>
        <v-btn icon color="red" @click="close" tile>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div class="d-flex align-center flex-column" v-if="isInitiated">
          <vue-qrcode
            :width="150"
            v-if="item.qrcode_url"
            :value="item.qrcode_url"
          />
        </div>
        <div class="subtitle-2">RECHARGE DETAILS</div>
        <v-card outlined tile>
          <v-list-item>
            <v-list-item-avatar>
              <image-view :src="getImage(details)" alt="" />
            </v-list-item-avatar>
            <v-list-item-content class="caption pa-1">
              Provider: {{ details.service }}
              <br />
              Phone: {{ details.rechargemobileno }}
              <br />
              Player: {{ details.payer_name }}
              <br />
              ID: {{ details.qrcode_txid }}
              <br />
              Payment Date: {{ details.recharge_date }}
            </v-list-item-content>
            <v-list-item-action>
              <div class="d-flex flex-column align-center">
                <div class="red--text">₹{{ details.amount }}</div>
                <status :status="details.recharge_status"></status>
              </div>
            </v-list-item-action>
          </v-list-item>
        </v-card>
        <div class="subtitle-2 mt-2">PAYMENT DETAILS</div>
        <v-card outlined tile>
          <v-list-item>
            <v-list-item-avatar tile>
              <image-view
                :src="require('../../../assets/images/bhim.png')"
                alt=""
              />
            </v-list-item-avatar>
            <v-list-item-content class="caption pa-1">
              From: {{ details.payer_vpa }}
              <br />
              Bank Id: {{ details.bank_rrn }}
              <br />
              Payment Date: {{ details.payment_date }}
            </v-list-item-content>
            <v-list-item-action>
              <div class="d-flex flex-column align-center">
                <div class="red--text">₹{{ details.total_amount }}</div>
                <status :status="details.payment_status"></status>
              </div>
            </v-list-item-action>
          </v-list-item>
        </v-card>
        <template v-if="isRefund">
          <div class="subtitle-2 mt-2">REFUND DETAILS</div>
          <v-card outlined tile>
            <v-list-item>
              <v-list-item-avatar tile>
                <image-view
                  :src="require('../../../assets/images/bhim.png')"
                  alt=""
                />
              </v-list-item-avatar>
              <v-list-item-content class="caption pa-1">
                Bank Id: {{ details.refund_transid }}
                <br />
                Payment Date: {{ details.refund_date }}
              </v-list-item-content>
              <v-list-item-action>
                <div class="d-flex flex-column align-center">
                  <div class="red--text">₹{{ details.total_amount }}</div>
                  <status :status="details.refund_status"></status>
                </div>
              </v-list-item-action>
            </v-list-item>
          </v-card>
        </template>
        <template v-if="!isFinished">
          <div class="d-flex align-center justify-center mt-4 mb-4">
            <v-progress-circular
              color="primary"
              indeterminate
            ></v-progress-circular>
            <div class="ml-2">
              Please wait
              <br />
              Fetching Information...
            </div>
          </div>
          <v-btn large color="primary" depressed dark block>
            It Takes too long <br />
            Check Status Manually
          </v-btn>
        </template>
        <template v-else>
          <v-row class="mt-4">
            <v-col cols="6">
              <v-btn @click="print()" depressed class="primary mr-3" tile block>
                Print</v-btn
              >
            </v-col>
            <v-col cols="6">
              <complaint :block="true" :id="details.autono"></complaint>
            </v-col>
          </v-row>
        </template>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import VueQrcode from "vue-qrcode";
import { getURL, printReceipt } from "../../../assets/js/common";
import rechargeService from "../../../assets/services/recharge.service";
import ImageView from "../../ImageView.vue";
import moment from "moment";
import Status from "../../reports/Status.vue";
import Complaint from "../../reports/Complaint.vue";
export default {
  components: {
    VueQrcode,
    ImageView,
    Status,
    Complaint,
  },
  data() {
    return {
      dialog: false,
      item: {},
      interval: null,
      details: {},
    };
  },
  computed: {
    isInitiated() {
      let { payment_status } = this.details;
      payment_status = payment_status ? payment_status.toUpperCase() : "";
      return payment_status == "INITIATED";
    },
    isRefund() {
      let { refund_status } = this.details;
      refund_status = refund_status ? refund_status.toLowerCase() : "";
      let isRefund = refund_status == "success" || refund_status == "failed";
      return isRefund;
    },
    isFinished() {
      let { payment_status, recharge_status, refund_status } = this.details;
      payment_status = payment_status ? payment_status.toLowerCase() : "";
      refund_status = refund_status ? refund_status.toLowerCase() : "";
      recharge_status = recharge_status ? recharge_status.toLowerCase() : "";
      let isSuccess =
        payment_status == "success" && recharge_status == "success";
      let isRefund = refund_status == "success";
      let isFailed =
        (refund_status == "failed" && recharge_status == "failed") ||
        payment_status == "failed";
      return isSuccess || isRefund || isFailed;
    },
  },
  methods: {
    print() {
      return printReceipt(this.details);
    },
    getColor(status) {
      status = status ? status.toLowerCase() : "";
      if (status == "success") return "green";
      if (status == "failed") return "red";
      return "primary";
    },
    format(date) {
      return moment(date, "MM/DD/YYYY hh:mm:ss a").format("DD-MM-YYYY hh:mm a");
    },
    getImage({ circle_img_path }) {
      if (!circle_img_path) return "";
      return getURL(circle_img_path.replace("/Admin", ""));
    },
    close() {
      const vm = this;
      if (vm.interval) {
        clearInterval(vm.interval);
      }
      let { recharge_status } = vm.details;
      recharge_status = recharge_status ? recharge_status.toLowerCase() : "";
      vm.$emit("close", recharge_status == "success");
      vm.dialog = false;
    },
    async init(params) {
      const vm = this;
      vm.item = {};
      vm.details = {};
      try {
        vm.$loader.show();
        let { data } = await rechargeService.doRecharge(params);
        if (data.status == "true") {
          vm.item = data.data;
          vm.dialog = true;
          vm.initInterval();
        } else {
          vm.$alert.show(data.message);
        }
        vm.$loader.hide();
      } catch (error) {
        vm.$loader.hide();
        vm.$alert.show(error.message);
      }
    },
    initInterval() {
      const vm = this;
      vm.fetch();
      vm.interval = setInterval(() => {
        vm.fetch();
        console.log("fetched");
      }, 5000);
    },
    async fetch() {
      const vm = this;
      try {
        let params = { Trans_Id: vm.item.qrcode_txid };
        let { data } = await rechargeService.getRechargeDetails(params);
        if (data.status == "true") {
          let item = data.data;
          let { payment_date, recharge_date, refund_date } = item;
          item.recharge_date = vm.format(recharge_date);
          item.payment_date = vm.format(payment_date);
          item.refund_date = vm.format(refund_date);
          vm.details = item;
        } else {
          vm.$alert.show(data.message);
        }
        if (vm.isFinished) {
          if (vm.interval) {
            clearInterval(vm.interval);
          }
        }
      } catch (error) {
        console.log(error);
        vm.$alert.show(error.message);
      }
    },
  },
};
</script>

<style>
</style>